export const isActiveErrorReport = (report: ErrorReport): boolean =>
  !report.meta.deleted_at;

export const groupActiveErrorReportsByEntityId = (
  errorReports: ErrorReport[],
): Record<string, ErrorReport[]> =>
  errorReports.reduce<Record<string, ErrorReport[]>>((acc, report) => {
    if (!isActiveErrorReport(report)) {
      return acc;
    }
    const byId = acc[report.entity_id] || [];
    byId.push(report);
    acc[report.entity_id] = byId;
    return acc;
  }, {});

export const countActiveErrorReportsByEntityId = (
  errorReports: ErrorReport[],
): Record<string, number> =>
  errorReports.reduce<Record<string, number>>((acc, report) => {
    if (!isActiveErrorReport(report)) {
      return acc;
    }
    acc[report.entity_id] = (acc[report.entity_id] ?? 0) + 1;
    return acc;
  }, {});
